export default __webpack_public_path__ + "1b0bcc9e2abe2ccb2da05529f0b6b1e6.png";